import { FC, SVGProps } from 'react';

const ChatAllIcon: FC<SVGProps<SVGSVGElement> & { size?: number }> = ({
  size = 20,
  color = '#3F906D',
  height = 24,
  width = 24,
  ...props
}) => {
  return (
    <svg width={size} height={size} viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg" {...props} fill="none">
      <path
        d="M7.54544 16.7759H3.70845C3.21143 16.7759 2.92831 16.2079 3.22749 15.811L4.02739 14.7499C4.13541 14.6067 4.12637 14.4078 4.01326 14.2685C3.06705 13.1033 2.5 11.6178 2.5 9.99992C2.5 6.25761 5.53372 3.22388 9.276 3.22388C11.2088 3.22388 12.9526 4.03309 14.187 5.33121"
        stroke={color}
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M13.2378 16.7762C10.8838 16.7762 8.97534 14.8678 8.97534 12.5137C8.97534 10.1596 10.8838 8.25122 13.2378 8.25122C15.5919 8.25122 17.5003 10.1596 17.5003 12.5137C17.5003 13.5315 17.1436 14.4659 16.5484 15.1989C16.4773 15.2865 16.4716 15.4117 16.5395 15.5017L17.0427 16.1692C17.2309 16.4189 17.0528 16.7762 16.7402 16.7762H13.2378Z"
        stroke={color}
        stroke-width="1.5"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export default ChatAllIcon;
